/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './../routes/__root'
import { Route as AuthImport } from './../routes/auth'
import { Route as MainLayoutImport } from './../routes/_mainLayout'
import { Route as AuthIndexImport } from './../routes/auth/index'
import { Route as MainLayoutIndexImport } from './../routes/_mainLayout/index'
import { Route as AuthSignInImport } from './../routes/auth/sign-in'
import { Route as MainLayoutProfileImport } from './../routes/_mainLayout/profile'
import { Route as MainLayoutWalletIndexImport } from './../routes/_mainLayout/wallet/index'
import { Route as MainLayoutWalletOldIndexImport } from './../routes/_mainLayout/wallet-old/index'
import { Route as MainLayoutTransactionsIndexImport } from './../routes/_mainLayout/transactions/index'
import { Route as MainLayoutRevsharePoolsIndexImport } from './../routes/_mainLayout/revshare-pools/index'
import { Route as MainLayoutRevsharePoolStatsIndexImport } from './../routes/_mainLayout/revshare-pool-stats/index'
import { Route as MainLayoutProfileIndexImport } from './../routes/_mainLayout/profile/index'
import { Route as MainLayoutPlayIndexImport } from './../routes/_mainLayout/play/index'
import { Route as MainLayoutLegalIndexImport } from './../routes/_mainLayout/legal/index'
import { Route as MainLayoutInnerReferralIndexImport } from './../routes/_mainLayout/inner-referral/index'
import { Route as MainLayoutCurrentmonthIndexImport } from './../routes/_mainLayout/current_month/index'
import { Route as MainLayoutClaimIndexImport } from './../routes/_mainLayout/claim/index'
import { Route as MainLayoutCardsIndexImport } from './../routes/_mainLayout/cards/index'
import { Route as MainLayoutWalletWithdrawIndexImport } from './../routes/_mainLayout/wallet/withdraw/index'
import { Route as MainLayoutWalletTransactionSuccessIndexImport } from './../routes/_mainLayout/wallet/transaction-success/index'
import { Route as MainLayoutWalletTransactionErrorIndexImport } from './../routes/_mainLayout/wallet/transaction-error/index'
import { Route as MainLayoutWalletSwapZenexIndexImport } from './../routes/_mainLayout/wallet/swap-zenex/index'
import { Route as MainLayoutWalletSwapDexIndexImport } from './../routes/_mainLayout/wallet/swap-dex/index'
import { Route as MainLayoutWalletDepositIndexImport } from './../routes/_mainLayout/wallet/deposit/index'
import { Route as MainLayoutProfileSafetyIndexImport } from './../routes/_mainLayout/profile/safety/index'
import { Route as MainLayoutProfileReferralIndexImport } from './../routes/_mainLayout/profile/referral/index'
import { Route as MainLayoutProfileQuestIndexImport } from './../routes/_mainLayout/profile/quest/index'
import { Route as MainLayoutProfileNotificationIndexImport } from './../routes/_mainLayout/profile/notification/index'
import { Route as MainLayoutProfileMobileMenuIndexImport } from './../routes/_mainLayout/profile/mobileMenu/index'
import { Route as MainLayoutProfileAccountIndexImport } from './../routes/_mainLayout/profile/account/index'
import { Route as MainLayoutWalletWaitDepositIndexImport } from './../routes/_mainLayout/wallet/wait/deposit/index'
import { Route as MainLayoutWalletSwapZenexWaitIndexImport } from './../routes/_mainLayout/wallet/swap-zenex/wait/index'
import { Route as MainLayoutRevsharePoolsYearMonthIndexImport } from './../routes/_mainLayout/revshare-pools/$year/$month/index'
import { Route as MainLayoutRevsharePoolStatsYearMonthIndexImport } from './../routes/_mainLayout/revshare-pool-stats/$year/$month/index'
import { Route as MainLayoutWalletSwapZenexDepositIdmKeyIndexImport } from './../routes/_mainLayout/wallet/swap-zenex/deposit/$idmKey/index'

// Create/Update Routes

const AuthRoute = AuthImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRoute,
} as any)

const MainLayoutRoute = MainLayoutImport.update({
  id: '/_mainLayout',
  getParentRoute: () => rootRoute,
} as any)

const AuthIndexRoute = AuthIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)

const MainLayoutIndexRoute = MainLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainLayoutRoute,
} as any)

const AuthSignInRoute = AuthSignInImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)

const MainLayoutProfileRoute = MainLayoutProfileImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => MainLayoutRoute,
} as any)

const MainLayoutWalletIndexRoute = MainLayoutWalletIndexImport.update({
  id: '/wallet/',
  path: '/wallet/',
  getParentRoute: () => MainLayoutRoute,
} as any)

const MainLayoutWalletOldIndexRoute = MainLayoutWalletOldIndexImport.update({
  id: '/wallet-old/',
  path: '/wallet-old/',
  getParentRoute: () => MainLayoutRoute,
} as any)

const MainLayoutTransactionsIndexRoute =
  MainLayoutTransactionsIndexImport.update({
    id: '/transactions/',
    path: '/transactions/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutRevsharePoolsIndexRoute =
  MainLayoutRevsharePoolsIndexImport.update({
    id: '/revshare-pools/',
    path: '/revshare-pools/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutRevsharePoolStatsIndexRoute =
  MainLayoutRevsharePoolStatsIndexImport.update({
    id: '/revshare-pool-stats/',
    path: '/revshare-pool-stats/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutProfileIndexRoute = MainLayoutProfileIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainLayoutProfileRoute,
} as any)

const MainLayoutPlayIndexRoute = MainLayoutPlayIndexImport.update({
  id: '/play/',
  path: '/play/',
  getParentRoute: () => MainLayoutRoute,
} as any)

const MainLayoutLegalIndexRoute = MainLayoutLegalIndexImport.update({
  id: '/legal/',
  path: '/legal/',
  getParentRoute: () => MainLayoutRoute,
} as any)

const MainLayoutInnerReferralIndexRoute =
  MainLayoutInnerReferralIndexImport.update({
    id: '/inner-referral/',
    path: '/inner-referral/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutCurrentmonthIndexRoute =
  MainLayoutCurrentmonthIndexImport.update({
    id: '/current_month/',
    path: '/current_month/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutClaimIndexRoute = MainLayoutClaimIndexImport.update({
  id: '/claim/',
  path: '/claim/',
  getParentRoute: () => MainLayoutRoute,
} as any)

const MainLayoutCardsIndexRoute = MainLayoutCardsIndexImport.update({
  id: '/cards/',
  path: '/cards/',
  getParentRoute: () => MainLayoutRoute,
} as any)

const MainLayoutWalletWithdrawIndexRoute =
  MainLayoutWalletWithdrawIndexImport.update({
    id: '/wallet/withdraw/',
    path: '/wallet/withdraw/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutWalletTransactionSuccessIndexRoute =
  MainLayoutWalletTransactionSuccessIndexImport.update({
    id: '/wallet/transaction-success/',
    path: '/wallet/transaction-success/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutWalletTransactionErrorIndexRoute =
  MainLayoutWalletTransactionErrorIndexImport.update({
    id: '/wallet/transaction-error/',
    path: '/wallet/transaction-error/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutWalletSwapZenexIndexRoute =
  MainLayoutWalletSwapZenexIndexImport.update({
    id: '/wallet/swap-zenex/',
    path: '/wallet/swap-zenex/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutWalletSwapDexIndexRoute =
  MainLayoutWalletSwapDexIndexImport.update({
    id: '/wallet/swap-dex/',
    path: '/wallet/swap-dex/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutWalletDepositIndexRoute =
  MainLayoutWalletDepositIndexImport.update({
    id: '/wallet/deposit/',
    path: '/wallet/deposit/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutProfileSafetyIndexRoute =
  MainLayoutProfileSafetyIndexImport.update({
    id: '/safety/',
    path: '/safety/',
    getParentRoute: () => MainLayoutProfileRoute,
  } as any)

const MainLayoutProfileReferralIndexRoute =
  MainLayoutProfileReferralIndexImport.update({
    id: '/referral/',
    path: '/referral/',
    getParentRoute: () => MainLayoutProfileRoute,
  } as any)

const MainLayoutProfileQuestIndexRoute =
  MainLayoutProfileQuestIndexImport.update({
    id: '/quest/',
    path: '/quest/',
    getParentRoute: () => MainLayoutProfileRoute,
  } as any)

const MainLayoutProfileNotificationIndexRoute =
  MainLayoutProfileNotificationIndexImport.update({
    id: '/notification/',
    path: '/notification/',
    getParentRoute: () => MainLayoutProfileRoute,
  } as any)

const MainLayoutProfileMobileMenuIndexRoute =
  MainLayoutProfileMobileMenuIndexImport.update({
    id: '/mobileMenu/',
    path: '/mobileMenu/',
    getParentRoute: () => MainLayoutProfileRoute,
  } as any)

const MainLayoutProfileAccountIndexRoute =
  MainLayoutProfileAccountIndexImport.update({
    id: '/account/',
    path: '/account/',
    getParentRoute: () => MainLayoutProfileRoute,
  } as any)

const MainLayoutWalletWaitDepositIndexRoute =
  MainLayoutWalletWaitDepositIndexImport.update({
    id: '/wallet/wait/deposit/',
    path: '/wallet/wait/deposit/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutWalletSwapZenexWaitIndexRoute =
  MainLayoutWalletSwapZenexWaitIndexImport.update({
    id: '/wallet/swap-zenex/wait/',
    path: '/wallet/swap-zenex/wait/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutRevsharePoolsYearMonthIndexRoute =
  MainLayoutRevsharePoolsYearMonthIndexImport.update({
    id: '/revshare-pools/$year/$month/',
    path: '/revshare-pools/$year/$month/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutRevsharePoolStatsYearMonthIndexRoute =
  MainLayoutRevsharePoolStatsYearMonthIndexImport.update({
    id: '/revshare-pool-stats/$year/$month/',
    path: '/revshare-pool-stats/$year/$month/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutWalletSwapZenexDepositIdmKeyIndexRoute =
  MainLayoutWalletSwapZenexDepositIdmKeyIndexImport.update({
    id: '/wallet/swap-zenex/deposit/$idmKey/',
    path: '/wallet/swap-zenex/deposit/$idmKey/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_mainLayout': {
      id: '/_mainLayout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MainLayoutImport
      parentRoute: typeof rootRoute
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_mainLayout/profile': {
      id: '/_mainLayout/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof MainLayoutProfileImport
      parentRoute: typeof MainLayoutImport
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInImport
      parentRoute: typeof AuthImport
    }
    '/_mainLayout/': {
      id: '/_mainLayout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MainLayoutIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexImport
      parentRoute: typeof AuthImport
    }
    '/_mainLayout/cards/': {
      id: '/_mainLayout/cards/'
      path: '/cards'
      fullPath: '/cards'
      preLoaderRoute: typeof MainLayoutCardsIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/claim/': {
      id: '/_mainLayout/claim/'
      path: '/claim'
      fullPath: '/claim'
      preLoaderRoute: typeof MainLayoutClaimIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/current_month/': {
      id: '/_mainLayout/current_month/'
      path: '/current_month'
      fullPath: '/current_month'
      preLoaderRoute: typeof MainLayoutCurrentmonthIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/inner-referral/': {
      id: '/_mainLayout/inner-referral/'
      path: '/inner-referral'
      fullPath: '/inner-referral'
      preLoaderRoute: typeof MainLayoutInnerReferralIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/legal/': {
      id: '/_mainLayout/legal/'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof MainLayoutLegalIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/play/': {
      id: '/_mainLayout/play/'
      path: '/play'
      fullPath: '/play'
      preLoaderRoute: typeof MainLayoutPlayIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/profile/': {
      id: '/_mainLayout/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof MainLayoutProfileIndexImport
      parentRoute: typeof MainLayoutProfileImport
    }
    '/_mainLayout/revshare-pool-stats/': {
      id: '/_mainLayout/revshare-pool-stats/'
      path: '/revshare-pool-stats'
      fullPath: '/revshare-pool-stats'
      preLoaderRoute: typeof MainLayoutRevsharePoolStatsIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/revshare-pools/': {
      id: '/_mainLayout/revshare-pools/'
      path: '/revshare-pools'
      fullPath: '/revshare-pools'
      preLoaderRoute: typeof MainLayoutRevsharePoolsIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/transactions/': {
      id: '/_mainLayout/transactions/'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof MainLayoutTransactionsIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet-old/': {
      id: '/_mainLayout/wallet-old/'
      path: '/wallet-old'
      fullPath: '/wallet-old'
      preLoaderRoute: typeof MainLayoutWalletOldIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/': {
      id: '/_mainLayout/wallet/'
      path: '/wallet'
      fullPath: '/wallet'
      preLoaderRoute: typeof MainLayoutWalletIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/profile/account/': {
      id: '/_mainLayout/profile/account/'
      path: '/account'
      fullPath: '/profile/account'
      preLoaderRoute: typeof MainLayoutProfileAccountIndexImport
      parentRoute: typeof MainLayoutProfileImport
    }
    '/_mainLayout/profile/mobileMenu/': {
      id: '/_mainLayout/profile/mobileMenu/'
      path: '/mobileMenu'
      fullPath: '/profile/mobileMenu'
      preLoaderRoute: typeof MainLayoutProfileMobileMenuIndexImport
      parentRoute: typeof MainLayoutProfileImport
    }
    '/_mainLayout/profile/notification/': {
      id: '/_mainLayout/profile/notification/'
      path: '/notification'
      fullPath: '/profile/notification'
      preLoaderRoute: typeof MainLayoutProfileNotificationIndexImport
      parentRoute: typeof MainLayoutProfileImport
    }
    '/_mainLayout/profile/quest/': {
      id: '/_mainLayout/profile/quest/'
      path: '/quest'
      fullPath: '/profile/quest'
      preLoaderRoute: typeof MainLayoutProfileQuestIndexImport
      parentRoute: typeof MainLayoutProfileImport
    }
    '/_mainLayout/profile/referral/': {
      id: '/_mainLayout/profile/referral/'
      path: '/referral'
      fullPath: '/profile/referral'
      preLoaderRoute: typeof MainLayoutProfileReferralIndexImport
      parentRoute: typeof MainLayoutProfileImport
    }
    '/_mainLayout/profile/safety/': {
      id: '/_mainLayout/profile/safety/'
      path: '/safety'
      fullPath: '/profile/safety'
      preLoaderRoute: typeof MainLayoutProfileSafetyIndexImport
      parentRoute: typeof MainLayoutProfileImport
    }
    '/_mainLayout/wallet/deposit/': {
      id: '/_mainLayout/wallet/deposit/'
      path: '/wallet/deposit'
      fullPath: '/wallet/deposit'
      preLoaderRoute: typeof MainLayoutWalletDepositIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/swap-dex/': {
      id: '/_mainLayout/wallet/swap-dex/'
      path: '/wallet/swap-dex'
      fullPath: '/wallet/swap-dex'
      preLoaderRoute: typeof MainLayoutWalletSwapDexIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/swap-zenex/': {
      id: '/_mainLayout/wallet/swap-zenex/'
      path: '/wallet/swap-zenex'
      fullPath: '/wallet/swap-zenex'
      preLoaderRoute: typeof MainLayoutWalletSwapZenexIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/transaction-error/': {
      id: '/_mainLayout/wallet/transaction-error/'
      path: '/wallet/transaction-error'
      fullPath: '/wallet/transaction-error'
      preLoaderRoute: typeof MainLayoutWalletTransactionErrorIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/transaction-success/': {
      id: '/_mainLayout/wallet/transaction-success/'
      path: '/wallet/transaction-success'
      fullPath: '/wallet/transaction-success'
      preLoaderRoute: typeof MainLayoutWalletTransactionSuccessIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/withdraw/': {
      id: '/_mainLayout/wallet/withdraw/'
      path: '/wallet/withdraw'
      fullPath: '/wallet/withdraw'
      preLoaderRoute: typeof MainLayoutWalletWithdrawIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/revshare-pool-stats/$year/$month/': {
      id: '/_mainLayout/revshare-pool-stats/$year/$month/'
      path: '/revshare-pool-stats/$year/$month'
      fullPath: '/revshare-pool-stats/$year/$month'
      preLoaderRoute: typeof MainLayoutRevsharePoolStatsYearMonthIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/revshare-pools/$year/$month/': {
      id: '/_mainLayout/revshare-pools/$year/$month/'
      path: '/revshare-pools/$year/$month'
      fullPath: '/revshare-pools/$year/$month'
      preLoaderRoute: typeof MainLayoutRevsharePoolsYearMonthIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/swap-zenex/wait/': {
      id: '/_mainLayout/wallet/swap-zenex/wait/'
      path: '/wallet/swap-zenex/wait'
      fullPath: '/wallet/swap-zenex/wait'
      preLoaderRoute: typeof MainLayoutWalletSwapZenexWaitIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/wait/deposit/': {
      id: '/_mainLayout/wallet/wait/deposit/'
      path: '/wallet/wait/deposit'
      fullPath: '/wallet/wait/deposit'
      preLoaderRoute: typeof MainLayoutWalletWaitDepositIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/swap-zenex/deposit/$idmKey/': {
      id: '/_mainLayout/wallet/swap-zenex/deposit/$idmKey/'
      path: '/wallet/swap-zenex/deposit/$idmKey'
      fullPath: '/wallet/swap-zenex/deposit/$idmKey'
      preLoaderRoute: typeof MainLayoutWalletSwapZenexDepositIdmKeyIndexImport
      parentRoute: typeof MainLayoutImport
    }
  }
}

// Create and export the route tree

interface MainLayoutProfileRouteChildren {
  MainLayoutProfileIndexRoute: typeof MainLayoutProfileIndexRoute
  MainLayoutProfileAccountIndexRoute: typeof MainLayoutProfileAccountIndexRoute
  MainLayoutProfileMobileMenuIndexRoute: typeof MainLayoutProfileMobileMenuIndexRoute
  MainLayoutProfileNotificationIndexRoute: typeof MainLayoutProfileNotificationIndexRoute
  MainLayoutProfileQuestIndexRoute: typeof MainLayoutProfileQuestIndexRoute
  MainLayoutProfileReferralIndexRoute: typeof MainLayoutProfileReferralIndexRoute
  MainLayoutProfileSafetyIndexRoute: typeof MainLayoutProfileSafetyIndexRoute
}

const MainLayoutProfileRouteChildren: MainLayoutProfileRouteChildren = {
  MainLayoutProfileIndexRoute: MainLayoutProfileIndexRoute,
  MainLayoutProfileAccountIndexRoute: MainLayoutProfileAccountIndexRoute,
  MainLayoutProfileMobileMenuIndexRoute: MainLayoutProfileMobileMenuIndexRoute,
  MainLayoutProfileNotificationIndexRoute:
    MainLayoutProfileNotificationIndexRoute,
  MainLayoutProfileQuestIndexRoute: MainLayoutProfileQuestIndexRoute,
  MainLayoutProfileReferralIndexRoute: MainLayoutProfileReferralIndexRoute,
  MainLayoutProfileSafetyIndexRoute: MainLayoutProfileSafetyIndexRoute,
}

const MainLayoutProfileRouteWithChildren =
  MainLayoutProfileRoute._addFileChildren(MainLayoutProfileRouteChildren)

interface MainLayoutRouteChildren {
  MainLayoutProfileRoute: typeof MainLayoutProfileRouteWithChildren
  MainLayoutIndexRoute: typeof MainLayoutIndexRoute
  MainLayoutCardsIndexRoute: typeof MainLayoutCardsIndexRoute
  MainLayoutClaimIndexRoute: typeof MainLayoutClaimIndexRoute
  MainLayoutCurrentmonthIndexRoute: typeof MainLayoutCurrentmonthIndexRoute
  MainLayoutInnerReferralIndexRoute: typeof MainLayoutInnerReferralIndexRoute
  MainLayoutLegalIndexRoute: typeof MainLayoutLegalIndexRoute
  MainLayoutPlayIndexRoute: typeof MainLayoutPlayIndexRoute
  MainLayoutRevsharePoolStatsIndexRoute: typeof MainLayoutRevsharePoolStatsIndexRoute
  MainLayoutRevsharePoolsIndexRoute: typeof MainLayoutRevsharePoolsIndexRoute
  MainLayoutTransactionsIndexRoute: typeof MainLayoutTransactionsIndexRoute
  MainLayoutWalletOldIndexRoute: typeof MainLayoutWalletOldIndexRoute
  MainLayoutWalletIndexRoute: typeof MainLayoutWalletIndexRoute
  MainLayoutWalletDepositIndexRoute: typeof MainLayoutWalletDepositIndexRoute
  MainLayoutWalletSwapDexIndexRoute: typeof MainLayoutWalletSwapDexIndexRoute
  MainLayoutWalletSwapZenexIndexRoute: typeof MainLayoutWalletSwapZenexIndexRoute
  MainLayoutWalletTransactionErrorIndexRoute: typeof MainLayoutWalletTransactionErrorIndexRoute
  MainLayoutWalletTransactionSuccessIndexRoute: typeof MainLayoutWalletTransactionSuccessIndexRoute
  MainLayoutWalletWithdrawIndexRoute: typeof MainLayoutWalletWithdrawIndexRoute
  MainLayoutRevsharePoolStatsYearMonthIndexRoute: typeof MainLayoutRevsharePoolStatsYearMonthIndexRoute
  MainLayoutRevsharePoolsYearMonthIndexRoute: typeof MainLayoutRevsharePoolsYearMonthIndexRoute
  MainLayoutWalletSwapZenexWaitIndexRoute: typeof MainLayoutWalletSwapZenexWaitIndexRoute
  MainLayoutWalletWaitDepositIndexRoute: typeof MainLayoutWalletWaitDepositIndexRoute
  MainLayoutWalletSwapZenexDepositIdmKeyIndexRoute: typeof MainLayoutWalletSwapZenexDepositIdmKeyIndexRoute
}

const MainLayoutRouteChildren: MainLayoutRouteChildren = {
  MainLayoutProfileRoute: MainLayoutProfileRouteWithChildren,
  MainLayoutIndexRoute: MainLayoutIndexRoute,
  MainLayoutCardsIndexRoute: MainLayoutCardsIndexRoute,
  MainLayoutClaimIndexRoute: MainLayoutClaimIndexRoute,
  MainLayoutCurrentmonthIndexRoute: MainLayoutCurrentmonthIndexRoute,
  MainLayoutInnerReferralIndexRoute: MainLayoutInnerReferralIndexRoute,
  MainLayoutLegalIndexRoute: MainLayoutLegalIndexRoute,
  MainLayoutPlayIndexRoute: MainLayoutPlayIndexRoute,
  MainLayoutRevsharePoolStatsIndexRoute: MainLayoutRevsharePoolStatsIndexRoute,
  MainLayoutRevsharePoolsIndexRoute: MainLayoutRevsharePoolsIndexRoute,
  MainLayoutTransactionsIndexRoute: MainLayoutTransactionsIndexRoute,
  MainLayoutWalletOldIndexRoute: MainLayoutWalletOldIndexRoute,
  MainLayoutWalletIndexRoute: MainLayoutWalletIndexRoute,
  MainLayoutWalletDepositIndexRoute: MainLayoutWalletDepositIndexRoute,
  MainLayoutWalletSwapDexIndexRoute: MainLayoutWalletSwapDexIndexRoute,
  MainLayoutWalletSwapZenexIndexRoute: MainLayoutWalletSwapZenexIndexRoute,
  MainLayoutWalletTransactionErrorIndexRoute:
    MainLayoutWalletTransactionErrorIndexRoute,
  MainLayoutWalletTransactionSuccessIndexRoute:
    MainLayoutWalletTransactionSuccessIndexRoute,
  MainLayoutWalletWithdrawIndexRoute: MainLayoutWalletWithdrawIndexRoute,
  MainLayoutRevsharePoolStatsYearMonthIndexRoute:
    MainLayoutRevsharePoolStatsYearMonthIndexRoute,
  MainLayoutRevsharePoolsYearMonthIndexRoute:
    MainLayoutRevsharePoolsYearMonthIndexRoute,
  MainLayoutWalletSwapZenexWaitIndexRoute:
    MainLayoutWalletSwapZenexWaitIndexRoute,
  MainLayoutWalletWaitDepositIndexRoute: MainLayoutWalletWaitDepositIndexRoute,
  MainLayoutWalletSwapZenexDepositIdmKeyIndexRoute:
    MainLayoutWalletSwapZenexDepositIdmKeyIndexRoute,
}

const MainLayoutRouteWithChildren = MainLayoutRoute._addFileChildren(
  MainLayoutRouteChildren,
)

interface AuthRouteChildren {
  AuthSignInRoute: typeof AuthSignInRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSignInRoute: AuthSignInRoute,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof MainLayoutRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/profile': typeof MainLayoutProfileRouteWithChildren
  '/auth/sign-in': typeof AuthSignInRoute
  '/': typeof MainLayoutIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/cards': typeof MainLayoutCardsIndexRoute
  '/claim': typeof MainLayoutClaimIndexRoute
  '/current_month': typeof MainLayoutCurrentmonthIndexRoute
  '/inner-referral': typeof MainLayoutInnerReferralIndexRoute
  '/legal': typeof MainLayoutLegalIndexRoute
  '/play': typeof MainLayoutPlayIndexRoute
  '/profile/': typeof MainLayoutProfileIndexRoute
  '/revshare-pool-stats': typeof MainLayoutRevsharePoolStatsIndexRoute
  '/revshare-pools': typeof MainLayoutRevsharePoolsIndexRoute
  '/transactions': typeof MainLayoutTransactionsIndexRoute
  '/wallet-old': typeof MainLayoutWalletOldIndexRoute
  '/wallet': typeof MainLayoutWalletIndexRoute
  '/profile/account': typeof MainLayoutProfileAccountIndexRoute
  '/profile/mobileMenu': typeof MainLayoutProfileMobileMenuIndexRoute
  '/profile/notification': typeof MainLayoutProfileNotificationIndexRoute
  '/profile/quest': typeof MainLayoutProfileQuestIndexRoute
  '/profile/referral': typeof MainLayoutProfileReferralIndexRoute
  '/profile/safety': typeof MainLayoutProfileSafetyIndexRoute
  '/wallet/deposit': typeof MainLayoutWalletDepositIndexRoute
  '/wallet/swap-dex': typeof MainLayoutWalletSwapDexIndexRoute
  '/wallet/swap-zenex': typeof MainLayoutWalletSwapZenexIndexRoute
  '/wallet/transaction-error': typeof MainLayoutWalletTransactionErrorIndexRoute
  '/wallet/transaction-success': typeof MainLayoutWalletTransactionSuccessIndexRoute
  '/wallet/withdraw': typeof MainLayoutWalletWithdrawIndexRoute
  '/revshare-pool-stats/$year/$month': typeof MainLayoutRevsharePoolStatsYearMonthIndexRoute
  '/revshare-pools/$year/$month': typeof MainLayoutRevsharePoolsYearMonthIndexRoute
  '/wallet/swap-zenex/wait': typeof MainLayoutWalletSwapZenexWaitIndexRoute
  '/wallet/wait/deposit': typeof MainLayoutWalletWaitDepositIndexRoute
  '/wallet/swap-zenex/deposit/$idmKey': typeof MainLayoutWalletSwapZenexDepositIdmKeyIndexRoute
}

export interface FileRoutesByTo {
  '/auth/sign-in': typeof AuthSignInRoute
  '/': typeof MainLayoutIndexRoute
  '/auth': typeof AuthIndexRoute
  '/cards': typeof MainLayoutCardsIndexRoute
  '/claim': typeof MainLayoutClaimIndexRoute
  '/current_month': typeof MainLayoutCurrentmonthIndexRoute
  '/inner-referral': typeof MainLayoutInnerReferralIndexRoute
  '/legal': typeof MainLayoutLegalIndexRoute
  '/play': typeof MainLayoutPlayIndexRoute
  '/profile': typeof MainLayoutProfileIndexRoute
  '/revshare-pool-stats': typeof MainLayoutRevsharePoolStatsIndexRoute
  '/revshare-pools': typeof MainLayoutRevsharePoolsIndexRoute
  '/transactions': typeof MainLayoutTransactionsIndexRoute
  '/wallet-old': typeof MainLayoutWalletOldIndexRoute
  '/wallet': typeof MainLayoutWalletIndexRoute
  '/profile/account': typeof MainLayoutProfileAccountIndexRoute
  '/profile/mobileMenu': typeof MainLayoutProfileMobileMenuIndexRoute
  '/profile/notification': typeof MainLayoutProfileNotificationIndexRoute
  '/profile/quest': typeof MainLayoutProfileQuestIndexRoute
  '/profile/referral': typeof MainLayoutProfileReferralIndexRoute
  '/profile/safety': typeof MainLayoutProfileSafetyIndexRoute
  '/wallet/deposit': typeof MainLayoutWalletDepositIndexRoute
  '/wallet/swap-dex': typeof MainLayoutWalletSwapDexIndexRoute
  '/wallet/swap-zenex': typeof MainLayoutWalletSwapZenexIndexRoute
  '/wallet/transaction-error': typeof MainLayoutWalletTransactionErrorIndexRoute
  '/wallet/transaction-success': typeof MainLayoutWalletTransactionSuccessIndexRoute
  '/wallet/withdraw': typeof MainLayoutWalletWithdrawIndexRoute
  '/revshare-pool-stats/$year/$month': typeof MainLayoutRevsharePoolStatsYearMonthIndexRoute
  '/revshare-pools/$year/$month': typeof MainLayoutRevsharePoolsYearMonthIndexRoute
  '/wallet/swap-zenex/wait': typeof MainLayoutWalletSwapZenexWaitIndexRoute
  '/wallet/wait/deposit': typeof MainLayoutWalletWaitDepositIndexRoute
  '/wallet/swap-zenex/deposit/$idmKey': typeof MainLayoutWalletSwapZenexDepositIdmKeyIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_mainLayout': typeof MainLayoutRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/_mainLayout/profile': typeof MainLayoutProfileRouteWithChildren
  '/auth/sign-in': typeof AuthSignInRoute
  '/_mainLayout/': typeof MainLayoutIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/_mainLayout/cards/': typeof MainLayoutCardsIndexRoute
  '/_mainLayout/claim/': typeof MainLayoutClaimIndexRoute
  '/_mainLayout/current_month/': typeof MainLayoutCurrentmonthIndexRoute
  '/_mainLayout/inner-referral/': typeof MainLayoutInnerReferralIndexRoute
  '/_mainLayout/legal/': typeof MainLayoutLegalIndexRoute
  '/_mainLayout/play/': typeof MainLayoutPlayIndexRoute
  '/_mainLayout/profile/': typeof MainLayoutProfileIndexRoute
  '/_mainLayout/revshare-pool-stats/': typeof MainLayoutRevsharePoolStatsIndexRoute
  '/_mainLayout/revshare-pools/': typeof MainLayoutRevsharePoolsIndexRoute
  '/_mainLayout/transactions/': typeof MainLayoutTransactionsIndexRoute
  '/_mainLayout/wallet-old/': typeof MainLayoutWalletOldIndexRoute
  '/_mainLayout/wallet/': typeof MainLayoutWalletIndexRoute
  '/_mainLayout/profile/account/': typeof MainLayoutProfileAccountIndexRoute
  '/_mainLayout/profile/mobileMenu/': typeof MainLayoutProfileMobileMenuIndexRoute
  '/_mainLayout/profile/notification/': typeof MainLayoutProfileNotificationIndexRoute
  '/_mainLayout/profile/quest/': typeof MainLayoutProfileQuestIndexRoute
  '/_mainLayout/profile/referral/': typeof MainLayoutProfileReferralIndexRoute
  '/_mainLayout/profile/safety/': typeof MainLayoutProfileSafetyIndexRoute
  '/_mainLayout/wallet/deposit/': typeof MainLayoutWalletDepositIndexRoute
  '/_mainLayout/wallet/swap-dex/': typeof MainLayoutWalletSwapDexIndexRoute
  '/_mainLayout/wallet/swap-zenex/': typeof MainLayoutWalletSwapZenexIndexRoute
  '/_mainLayout/wallet/transaction-error/': typeof MainLayoutWalletTransactionErrorIndexRoute
  '/_mainLayout/wallet/transaction-success/': typeof MainLayoutWalletTransactionSuccessIndexRoute
  '/_mainLayout/wallet/withdraw/': typeof MainLayoutWalletWithdrawIndexRoute
  '/_mainLayout/revshare-pool-stats/$year/$month/': typeof MainLayoutRevsharePoolStatsYearMonthIndexRoute
  '/_mainLayout/revshare-pools/$year/$month/': typeof MainLayoutRevsharePoolsYearMonthIndexRoute
  '/_mainLayout/wallet/swap-zenex/wait/': typeof MainLayoutWalletSwapZenexWaitIndexRoute
  '/_mainLayout/wallet/wait/deposit/': typeof MainLayoutWalletWaitDepositIndexRoute
  '/_mainLayout/wallet/swap-zenex/deposit/$idmKey/': typeof MainLayoutWalletSwapZenexDepositIdmKeyIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/auth'
    | '/profile'
    | '/auth/sign-in'
    | '/'
    | '/auth/'
    | '/cards'
    | '/claim'
    | '/current_month'
    | '/inner-referral'
    | '/legal'
    | '/play'
    | '/profile/'
    | '/revshare-pool-stats'
    | '/revshare-pools'
    | '/transactions'
    | '/wallet-old'
    | '/wallet'
    | '/profile/account'
    | '/profile/mobileMenu'
    | '/profile/notification'
    | '/profile/quest'
    | '/profile/referral'
    | '/profile/safety'
    | '/wallet/deposit'
    | '/wallet/swap-dex'
    | '/wallet/swap-zenex'
    | '/wallet/transaction-error'
    | '/wallet/transaction-success'
    | '/wallet/withdraw'
    | '/revshare-pool-stats/$year/$month'
    | '/revshare-pools/$year/$month'
    | '/wallet/swap-zenex/wait'
    | '/wallet/wait/deposit'
    | '/wallet/swap-zenex/deposit/$idmKey'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth/sign-in'
    | '/'
    | '/auth'
    | '/cards'
    | '/claim'
    | '/current_month'
    | '/inner-referral'
    | '/legal'
    | '/play'
    | '/profile'
    | '/revshare-pool-stats'
    | '/revshare-pools'
    | '/transactions'
    | '/wallet-old'
    | '/wallet'
    | '/profile/account'
    | '/profile/mobileMenu'
    | '/profile/notification'
    | '/profile/quest'
    | '/profile/referral'
    | '/profile/safety'
    | '/wallet/deposit'
    | '/wallet/swap-dex'
    | '/wallet/swap-zenex'
    | '/wallet/transaction-error'
    | '/wallet/transaction-success'
    | '/wallet/withdraw'
    | '/revshare-pool-stats/$year/$month'
    | '/revshare-pools/$year/$month'
    | '/wallet/swap-zenex/wait'
    | '/wallet/wait/deposit'
    | '/wallet/swap-zenex/deposit/$idmKey'
  id:
    | '__root__'
    | '/_mainLayout'
    | '/auth'
    | '/_mainLayout/profile'
    | '/auth/sign-in'
    | '/_mainLayout/'
    | '/auth/'
    | '/_mainLayout/cards/'
    | '/_mainLayout/claim/'
    | '/_mainLayout/current_month/'
    | '/_mainLayout/inner-referral/'
    | '/_mainLayout/legal/'
    | '/_mainLayout/play/'
    | '/_mainLayout/profile/'
    | '/_mainLayout/revshare-pool-stats/'
    | '/_mainLayout/revshare-pools/'
    | '/_mainLayout/transactions/'
    | '/_mainLayout/wallet-old/'
    | '/_mainLayout/wallet/'
    | '/_mainLayout/profile/account/'
    | '/_mainLayout/profile/mobileMenu/'
    | '/_mainLayout/profile/notification/'
    | '/_mainLayout/profile/quest/'
    | '/_mainLayout/profile/referral/'
    | '/_mainLayout/profile/safety/'
    | '/_mainLayout/wallet/deposit/'
    | '/_mainLayout/wallet/swap-dex/'
    | '/_mainLayout/wallet/swap-zenex/'
    | '/_mainLayout/wallet/transaction-error/'
    | '/_mainLayout/wallet/transaction-success/'
    | '/_mainLayout/wallet/withdraw/'
    | '/_mainLayout/revshare-pool-stats/$year/$month/'
    | '/_mainLayout/revshare-pools/$year/$month/'
    | '/_mainLayout/wallet/swap-zenex/wait/'
    | '/_mainLayout/wallet/wait/deposit/'
    | '/_mainLayout/wallet/swap-zenex/deposit/$idmKey/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  MainLayoutRoute: typeof MainLayoutRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  MainLayoutRoute: MainLayoutRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_mainLayout",
        "/auth"
      ]
    },
    "/_mainLayout": {
      "filePath": "_mainLayout.tsx",
      "children": [
        "/_mainLayout/profile",
        "/_mainLayout/",
        "/_mainLayout/cards/",
        "/_mainLayout/claim/",
        "/_mainLayout/current_month/",
        "/_mainLayout/inner-referral/",
        "/_mainLayout/legal/",
        "/_mainLayout/play/",
        "/_mainLayout/revshare-pool-stats/",
        "/_mainLayout/revshare-pools/",
        "/_mainLayout/transactions/",
        "/_mainLayout/wallet-old/",
        "/_mainLayout/wallet/",
        "/_mainLayout/wallet/deposit/",
        "/_mainLayout/wallet/swap-dex/",
        "/_mainLayout/wallet/swap-zenex/",
        "/_mainLayout/wallet/transaction-error/",
        "/_mainLayout/wallet/transaction-success/",
        "/_mainLayout/wallet/withdraw/",
        "/_mainLayout/revshare-pool-stats/$year/$month/",
        "/_mainLayout/revshare-pools/$year/$month/",
        "/_mainLayout/wallet/swap-zenex/wait/",
        "/_mainLayout/wallet/wait/deposit/",
        "/_mainLayout/wallet/swap-zenex/deposit/$idmKey/"
      ]
    },
    "/auth": {
      "filePath": "auth.tsx",
      "children": [
        "/auth/sign-in",
        "/auth/"
      ]
    },
    "/_mainLayout/profile": {
      "filePath": "_mainLayout/profile.tsx",
      "parent": "/_mainLayout",
      "children": [
        "/_mainLayout/profile/",
        "/_mainLayout/profile/account/",
        "/_mainLayout/profile/mobileMenu/",
        "/_mainLayout/profile/notification/",
        "/_mainLayout/profile/quest/",
        "/_mainLayout/profile/referral/",
        "/_mainLayout/profile/safety/"
      ]
    },
    "/auth/sign-in": {
      "filePath": "auth/sign-in.tsx",
      "parent": "/auth"
    },
    "/_mainLayout/": {
      "filePath": "_mainLayout/index.tsx",
      "parent": "/_mainLayout"
    },
    "/auth/": {
      "filePath": "auth/index.tsx",
      "parent": "/auth"
    },
    "/_mainLayout/cards/": {
      "filePath": "_mainLayout/cards/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/claim/": {
      "filePath": "_mainLayout/claim/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/current_month/": {
      "filePath": "_mainLayout/current_month/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/inner-referral/": {
      "filePath": "_mainLayout/inner-referral/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/legal/": {
      "filePath": "_mainLayout/legal/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/play/": {
      "filePath": "_mainLayout/play/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/profile/": {
      "filePath": "_mainLayout/profile/index.tsx",
      "parent": "/_mainLayout/profile"
    },
    "/_mainLayout/revshare-pool-stats/": {
      "filePath": "_mainLayout/revshare-pool-stats/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/revshare-pools/": {
      "filePath": "_mainLayout/revshare-pools/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/transactions/": {
      "filePath": "_mainLayout/transactions/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet-old/": {
      "filePath": "_mainLayout/wallet-old/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/": {
      "filePath": "_mainLayout/wallet/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/profile/account/": {
      "filePath": "_mainLayout/profile/account/index.tsx",
      "parent": "/_mainLayout/profile"
    },
    "/_mainLayout/profile/mobileMenu/": {
      "filePath": "_mainLayout/profile/mobileMenu/index.tsx",
      "parent": "/_mainLayout/profile"
    },
    "/_mainLayout/profile/notification/": {
      "filePath": "_mainLayout/profile/notification/index.tsx",
      "parent": "/_mainLayout/profile"
    },
    "/_mainLayout/profile/quest/": {
      "filePath": "_mainLayout/profile/quest/index.tsx",
      "parent": "/_mainLayout/profile"
    },
    "/_mainLayout/profile/referral/": {
      "filePath": "_mainLayout/profile/referral/index.tsx",
      "parent": "/_mainLayout/profile"
    },
    "/_mainLayout/profile/safety/": {
      "filePath": "_mainLayout/profile/safety/index.tsx",
      "parent": "/_mainLayout/profile"
    },
    "/_mainLayout/wallet/deposit/": {
      "filePath": "_mainLayout/wallet/deposit/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/swap-dex/": {
      "filePath": "_mainLayout/wallet/swap-dex/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/swap-zenex/": {
      "filePath": "_mainLayout/wallet/swap-zenex/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/transaction-error/": {
      "filePath": "_mainLayout/wallet/transaction-error/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/transaction-success/": {
      "filePath": "_mainLayout/wallet/transaction-success/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/withdraw/": {
      "filePath": "_mainLayout/wallet/withdraw/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/revshare-pool-stats/$year/$month/": {
      "filePath": "_mainLayout/revshare-pool-stats/$year/$month/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/revshare-pools/$year/$month/": {
      "filePath": "_mainLayout/revshare-pools/$year/$month/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/swap-zenex/wait/": {
      "filePath": "_mainLayout/wallet/swap-zenex/wait/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/wait/deposit/": {
      "filePath": "_mainLayout/wallet/wait/deposit/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/swap-zenex/deposit/$idmKey/": {
      "filePath": "_mainLayout/wallet/swap-zenex/deposit/$idmKey/index.tsx",
      "parent": "/_mainLayout"
    }
  }
}
ROUTE_MANIFEST_END */
